import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { RecordContextProvider } from "react-admin";
import { ActiveStudentsField } from "../fields/ActiveStudentsField";
import { StudentsIcon } from "../icons/StudentsIcon";
import { Column } from "../misc/Column";
import { Row } from "../misc/Row";
import type { Instructor } from "../providers/instructorsProvider";
import { EmployeeAvatar } from "../misc/EmployeeAvatar";

export function InstructorMobileListItem(props: { instructor: Instructor; onClick: () => void }) {
  const { instructor, onClick } = props;
  const theme = useTheme();
  const role = instructor.isDrivingSchoolManager ? "Fahrschulleiter" : "Fahrlehrer";
  const drivingLicenseClasses = instructor.instructing.drivingLicenseClasses.join(", ");

  return (
    <RecordContextProvider value={instructor}>
      <ButtonBase
        data-testid="InstructorMobileListItem"
        onClick={onClick}
        sx={{
          alignItems: "stretch",
          borderBottom: `1px solid ${theme.palette.divider}`,
          boxSizing: "border-box",
          display: "block",
          px: 0,
          py: 1,
          textAlign: "left",
          width: "100%",
        }}
      >
        <Box sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}>
          <EmployeeAvatar src={instructor.avatarUrl} sx={{ flexShrink: 0, height: 40, width: 40 }} />
          <Column sx={{ flex: 1, gap: 0.25, minWidth: 0 }}>
            <Typography
              variant="body1"
              color={instructor.isActive ? "text.primary" : "text.disabled"}
              sx={{ fontWeight: 600, overflowWrap: "anywhere" }}
            >
              {instructor.name}
            </Typography>
            <Typography variant="caption" color={instructor.isActive ? "text.secondary" : "text.disabled"}>
              {[role, drivingLicenseClasses].filter(Boolean).join(" · ")}
            </Typography>
          </Column>
          <Row
            gap={0.5}
            sx={{
              alignItems: "center",
              color: instructor.isActive ? "text.secondary" : "text.disabled",
              flexShrink: 0,
            }}
          >
            <ActiveStudentsField />
            <StudentsIcon sx={{ fill: "currentColor", fontSize: 18 }} />
          </Row>
        </Box>
      </ButtonBase>
    </RecordContextProvider>
  );
}
